export default {
  "authenticated-10-column": () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/authenticated-10-column.vue"),
  default: () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/default.vue"),
  "dynamic-content": () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/dynamic-content.vue"),
  "full-width": () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/full-width.vue"),
  loyalty: () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/loyalty.vue"),
  "my-profile-with-paging": () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/my-profile-with-paging.vue"),
  "my-profile": () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/my-profile.vue"),
  profile: () => import("/builds/auchan-webshop/auchan-vue-client/shop/layouts/profile.vue")
}